/* Venlu R23 · kleine Verhaltensbausteine zu Robins Review vom 10.10.2026.
   Kein Scroll-Listener: Sichtbarkeit über IntersectionObserver. Theme-Editor: shopify:section:load bindet neu, ohne doppelte Listener. */
(() => {
  const d = document;

  /* A5: Staubteilchen im Hero stehen still, solange der Hero nicht sichtbar ist */
  function heroIdle(scope) {
    const hero = scope.querySelector('.r19-hero');
    if (!hero || hero.dataset.r23Idle) return; hero.dataset.r23Idle = '1';
    new IntersectionObserver(([e]) => hero.classList.toggle('is-off', !e.isIntersecting)).observe(hero);
  }

  /* Horizontale Reihen (Drop-Zeilen, Schmuck): Pfeile blättern um eine sichtbare Breite, Zustand am Rand */
  function rails(scope) {
    scope.querySelectorAll('[data-r23-rail]').forEach(wrap => {
      if (wrap.dataset.r23Bound) return; wrap.dataset.r23Bound = '1';
      const track = wrap.querySelector('[data-r23-track]'); if (!track) return;
      const prev = wrap.querySelector('[data-r23-prev]'), next = wrap.querySelector('[data-r23-next]');
      let pending = 0, max = 0, width = 0, geometryDirty = true;
      const sync = () => {
        pending = 0;
        if (geometryDirty) { width = track.clientWidth; max = track.scrollWidth - width - 2; geometryDirty = false; }
        const left = track.scrollLeft;
        if (prev) prev.disabled = left <= 2;
        if (next) next.disabled = left >= max;
        wrap.classList.toggle('is-scrollable', max > 2);
      };
      const schedule = () => { if (!pending) pending = requestAnimationFrame(sync); };
      const measure = () => { geometryDirty = true; schedule(); };
      const step = dir => track.scrollBy({ left: dir * Math.max(200, width * 0.85), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      prev && prev.addEventListener('click', () => step(-1));
      next && next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', schedule, { passive: true });
      new ResizeObserver(measure).observe(track);
      new MutationObserver(measure).observe(track, { childList: true });
      track.addEventListener('load', measure, true); sync();
    });
  }


  /* A12: Set-Preisrechner auf der Produktseite (Preis dieses Teils × Anzahl, Rabatt der Set-Staffel) */
  function calc(scope) {
    scope.querySelectorAll('[data-r23-calc]').forEach(el => {
      if (el.dataset.r23Bound) return; el.dataset.r23Bound = '1';
      const btns = [...el.querySelectorAll('[data-n]')]; let n = 2;
      const f = (el.dataset.fmt || '€12,34').match(/^(.*?)12(\D)34(.*)$/) || [null, '€', ',', ''];
      const fmt = c => f[1] + Math.floor(c / 100) + f[2] + String(c % 100).padStart(2, '0') + f[3];
      const sel = d.querySelector('#vn-variant');
      const cents = () => { const o = sel && sel.selectedOptions[0]; return Number(o && o.dataset.cents) || Number(el.dataset.cents) || 0; };
      const q = s => el.querySelector(s);
      const render = () => {
        const c = cents(), p = Number(el.dataset['p' + n]) || 0, sum = c * n, nw = Math.floor(sum * (100 - p) / 100);
        btns.forEach(b => { const on = Number(b.dataset.n) === n; b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
        q('[data-r23-calc-k]').textContent = n + ' × ' + fmt(c);
        q('[data-r23-calc-old]').textContent = fmt(sum);
        q('[data-r23-calc-new]').textContent = fmt(nw);
        q('[data-r23-calc-save] b').textContent = fmt(sum - nw);
      };
      btns.forEach((b, i) => {
        b.addEventListener('click', () => { n = Number(b.dataset.n); render(); });
        b.addEventListener('keydown', e => {
          let j = null; if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % btns.length; if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + btns.length) % btns.length;
          if (j !== null) { e.preventDefault(); n = Number(btns[j].dataset.n); render(); btns[j].focus(); }
        });
      });
      const form = d.getElementById('vn-product-form');
      (form || sel) && (form || sel).addEventListener('change', () => setTimeout(render, 0));
      form && form.addEventListener('click', () => setTimeout(render, 0));
      render();
    });
  }


  /* A8: Schmuck in Bestseller-Reihenfolge (Section Rendering API mit sort_by=best-selling), ersetzt die Liste einmal */
  function bestsellers(scope) {
    scope.querySelectorAll('[data-r23-best]').forEach(wrap => {
      if (wrap.dataset.r23BestBound) return; wrap.dataset.r23BestBound = '1';
      const track = wrap.querySelector('[data-r23-track]'); const base = wrap.dataset.r23Best; if (!track || !base) return;
      const go = () => fetch(base + (base.includes('?') ? '&' : '?') + 'sort_by=best-selling&sections=r23-jewel-list', { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null).then(j => {
          const html = j && j['r23-jewel-list']; if (!html) return;
          const tmp = d.createElement('div'); tmp.innerHTML = html;
          const ul = tmp.querySelector('[data-r23-best-list]'); if (!ul || ul.children.length < 3) return;
          track.innerHTML = ul.innerHTML; track.scrollLeft = 0; wrap.dataset.r23Sorted = 'best-selling';
          track.dispatchEvent(new Event('scroll'));
        }).catch(() => {});
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '600px 0px' });
      io.observe(wrap);
    });
  }


  /* R24 A15: „Jetzt kaufen“ legt die gewählte Variante in den Warenkorb und öffnet direkt die Kasse */
  function buyNow(scope) {
    scope.querySelectorAll('[data-r24-buynow]').forEach(btn => {
      if (btn.dataset.r24Bound) return; btn.dataset.r24Bound = '1';
      const form = btn.closest('form'); const add = form && form.querySelector('.add-to-cart');
      const sync = () => { if (add) btn.disabled = add.disabled; };
      if (add) { new MutationObserver(sync).observe(add, { attributes: true, attributeFilter: ['disabled'] }); sync(); }
      // venlu-purchase-r17.js owns the native submit event for both actions.
      // Do not issue a separate request or replay the add after a failure.
    });
  }

  /* R24 A17: Erfolg am auslösenden Knopf (Haken), neue Warenkorb-Zeile leuchtet, Fortschritt füllt sich sichtbar */
  function cartFx() {
    if (d.documentElement.dataset.r24Fx) return; d.documentElement.dataset.r24Fx = '1';
    d.addEventListener('venlu:cart-added', e => {
      const t = e.detail && e.detail.trigger; const btn = t && (t.closest ? (t.closest('button') || t) : null);
      if (btn && btn.classList) { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1600); }
      d.documentElement.dataset.r24JustAdded = '1'; setTimeout(() => { delete d.documentElement.dataset.r24JustAdded; }, 2500);
    });
    const decorate = root => {
      root.querySelectorAll('.vn-cart-line').forEach((l, i) => l.style.setProperty('--i', i));
      if (d.documentElement.dataset.r24JustAdded) { const first = root.querySelector('.vn-cart-line'); if (first && !first.classList.contains('r24-new')) first.classList.add('r24-new'); }
      // Shopify's new render owns --s. The drawer CSS supplies the finite entry
      // animation; replaying a JS tween during later status mutations can restore
      // an obsolete value after a quantity update.
    };
    const dlg = d.querySelector('.vn-cart-dialog');
    if (dlg) { decorate(dlg); new MutationObserver(() => decorate(dlg)).observe(dlg, { childList: true, subtree: true }); }
  }


  /* R24 A11: Film-Umschalter auf der Drop-Seite (stumm, nur sichtbarer Film lädt) */
  function filmSwitch(scope) {
    scope.querySelectorAll('.r24-filmswitch').forEach(g => {
      if (g.dataset.r24Bound) return; g.dataset.r24Bound = '1';
      const film = g.previousElementSibling && g.previousElementSibling.matches('r21-loop, .r21-dl__film') ? g.previousElementSibling : g.parentElement.querySelector('.r21-dl__film');
      if (!film) return;
      const btns = [...g.querySelectorAll('[data-r24-film]')];
      btns.forEach(b => b.addEventListener('click', () => {
        if (b.getAttribute('aria-pressed') === 'true') return;
        btns.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        const img = film.querySelector('img'); const v = film.querySelector('video');
        if (img) { img.removeAttribute('srcset'); img.src = b.dataset.r24Poster; }
        film.classList.remove('is-playing');
        if (v) {
          v.pause(); v.muted = true; v.defaultMuted = true; v.volume = 0; v.dataset.src = b.dataset.r24Film; v.removeAttribute('src');
          const calm = matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData);
          if (!calm) { v.src = b.dataset.r24Film; v.addEventListener('playing', () => film.classList.add('is-playing'), { once: true }); v.load(); const pr = v.play(); if (pr && pr.catch) pr.catch(() => {}); }
        }
      }));
    });
  }


  /* R24 A13: Drop-Seite, Prime I „weitere Figuren laden“ (sichtbare Anzahl verdoppeln; Rest vollständig, Zähler aktuell) */
  function dlMore(scope) {
    scope.querySelectorAll('[data-r24-more-btn]').forEach(b => {
      if (b.dataset.r24Bound) return; b.dataset.r24Bound = '1';
      const root = b.closest('[data-r21-drop]') || d; const box = b.closest('.r24-more');
      const hint = box && box.querySelector('[data-r24-hint]'); const de = (d.body.dataset.locale || d.documentElement.lang || '').startsWith('de');
      const upd = () => {
        const left = root.querySelectorAll('[data-r24-more][hidden]').length;
        const n = b.querySelector('[data-n]'); if (n) n.textContent = left;
        if (hint) { const vis = root.querySelectorAll('.r23-dlrow:not([hidden])').length, tot = hint.dataset.total; hint.textContent = window.VenluI18n.t("r24.s_8d4c68314e31",{p1:(vis),p2:(tot)},"{{ p1 }} of {{ p2 }} characters"); }
        b.hidden = !left;
      };
      b.addEventListener('click', () => {
        const visible = root.querySelectorAll('.r23-dlrow:not([hidden])').length;
        const next = [...root.querySelectorAll('[data-r24-more][hidden]')].slice(0, Math.max(1, visible));
        next.forEach((a, i) => { a.hidden = false; a.style.setProperty('--r24-d', (Math.min(i, 5) * 60) + 'ms'); a.classList.add('r24-reveal'); });
        const h = next[0] && next[0].querySelector('h2');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
        upd();
        root.dispatchEvent(new CustomEvent('venlu:dropmore'));
      });
      // Character links from Home must reach a visible Prime-I row.
      const revealHash = () => {
        if (!root.isConnected) return;
        let id; try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
        if (!/^figur-[a-z0-9-]+$/.test(id)) return;
        const target = d.getElementById(id);
        if (!target || !root.contains(target) || !target.matches('.r23-dlrow')) return;
        const rows = [...root.querySelectorAll('[data-r24-more]')], end = rows.indexOf(target);
        if (target.hidden && end < 0) return;
        if (end >= 0) rows.slice(0, end + 1).forEach(row => { row.hidden = false; });
        upd(); root.dispatchEvent(new CustomEvent('venlu:dropmore'));
        requestAnimationFrame(() => { if (target.isConnected) target.scrollIntoView({ block: 'start', behavior: 'instant' }); });
      };
      window.addEventListener('hashchange', revealHash);
      revealHash();
    });
  }


  /* R24 A5: „Wähle deine Seite“ – Reiter (Pfeiltasten) und gewählte Seite (Zeigen, Fokus oder Tippen) */
  function duel(scope) {
    scope.querySelectorAll('[data-r24-duel]').forEach(root => {
      if (root.matches('r26-duo-player')) return;
      if (root.dataset.r24Bound) return; root.dataset.r24Bound = '1';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const show = t => tabs.forEach(x => {
        const on = x === t; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1;
        const pnl = d.getElementById(x.getAttribute('aria-controls'));
        if (pnl) { pnl.hidden = !on; if (on) { pnl.classList.remove('r24-in'); void pnl.offsetWidth; pnl.classList.add('r24-in'); } }
      });
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => show(t));
        t.addEventListener('keydown', e => {
          const k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!k) return;
          e.preventDefault(); const n = tabs[(i + k + tabs.length) % tabs.length]; n.focus(); show(n);
        });
      });
      const hover = matchMedia('(hover: hover) and (pointer: fine)');
      root.querySelectorAll('.r24-duel__pair').forEach(pair => {
        const sides = [...pair.querySelectorAll('[data-r24-side]')];
        const set = s => sides.forEach(x => { const on = x === s; x.classList.toggle('is-on', on); const b = x.querySelector('[data-r24-pick]'); if (b) b.setAttribute('aria-pressed', String(on)); });
        sides.forEach(s => {
          s.addEventListener('mouseenter', () => { if (hover.matches) set(s); });
          s.addEventListener('focusin', () => set(s));
          const b = s.querySelector('[data-r24-pick]'); if (b) b.addEventListener('click', () => set(s));
        });
      });
    });
  }


  /* Total delivery estimate in calendar days, including processing: Robin, 12.10.2026. */
  function eta(scope) {
    scope.querySelectorAll('[data-r24-eta]').forEach(el => {
      if (el.dataset.r24Bound) return; el.dataset.r24Bound = '1';
      const add = n => { const t = new Date(); t.setDate(t.getDate() + n); return t; };
      const lo = parseInt(el.dataset.min, 10), hi = parseInt(el.dataset.max, 10); if (!(hi > 0)) return;
      const de = (d.body.dataset.locale || d.documentElement.lang || '').startsWith('de');
      const f = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { weekday: 'short', day: 'numeric', month: de ? '2-digit' : 'short' });
      el.textContent = (window.VenluI18n.t("r24.s_26bd0334a033",{},"Estimated delivery: ")) + f.format(add(lo || 1)) + ' – ' + f.format(add(hi));
      el.hidden = false;
    });
  }

  const init = (scope = d) => { heroIdle(scope); rails(scope); calc(scope); bestsellers(scope); buyNow(scope); cartFx(); filmSwitch(scope); dlMore(scope); duel(scope); eta(scope); };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', () => init()); else init();
  d.addEventListener('shopify:section:load', e => init(e.target));
})();
